export default __webpack_public_path__ + "static/media/rightArrow.ffce32da.svg";